export const UPLOAD_VIDEO_MODAL_CONSTS = {
  cancelMsg: 'Отмена',
  includeInNews: 'Добавить в новость',
  fillRequiredFields: 'Заполните обязательные поля'
}
